/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import { types } from 'mobx-state-tree';
import { generateUniqueId } from './utils';

const Style = types.model({
	top:    types.union( types.string, types.undefined),
	left:   types.union( types.string, types.undefined),
	height: types.union( types.string, types.undefined),
	width:  types.union( types.string, types.undefined)
}).volatile(()=>({
	display: undefined
}));


export const MSTLayoutModelBase = types.model({
	id:                 types.optional(types.identifier, generateUniqueId('model')),
	type:               types.union( types.string, types.undefined),
	title:              types.union( types.string, types.undefined),
	from:               types.union( types.string, types.undefined),
	style:              types.union( Style, types.undefined ),
	templateName:       types.union( types.string, types.undefined),
	clones:             types.union( types.number, types.undefined),
	css:                types.union( types.string, types.undefined), //?
	relatedLayouts:     types.union( types.string, types.undefined),
	fillColor:          types.union( types.string, types.undefined),
	disableScrollDrop:  types.union( types.boolean, types.undefined),

	items:              types.union(
		types.array(
			types.late(()=>MSTLayoutModelBase)
		),
		types.undefined)
}).preProcessSnapshot(snapshot => {
	//sanity check, mobx does not like null snapshot
	if(snapshot === null) {
		return {};
	}
	return snapshot;
});



// WEBPACK FOOTER //
// ./src/js/core/MSTLayoutModelBase.js